import { initStore }    from '../src/store';
import withRematch      from '../src/utils/withRematch';
import Layout           from '../src/containers/MineLayout';
import Tariffs          from '../src/containers/Tariffs';

const TariffPage = (props) => {
    return (
        <Layout {...props}>
            <Tariffs lang={props.lang} />
        </Layout>
    );
};

TariffPage.getInitialProps = async function(ctx) {
    const { pathname, req, store } = ctx;

    let token = req ? req.cookies.token : null;

    await store.dispatch.user.getUserInfoFull({token});

    let curLang = req && req.language ? req.language.split('-')[0] : 'ru';

    return {
        headerClass: '',
        curLang,
        pathname,
        title: 'MOVER: Тарифы',
        description: 'Тарифы MOVER полностью прозрачные и не содержат скрытых доплат. Закажите MOVER от 580 ₽/час. Тарифы различаются по цене, типам и размерам автомобилей, выбирайте подходящий себе и экономьте. Разные тарифы хорошо подходят для разных задач. Также вы можете выбрать дополнительные услуги — грузчики, упаковка, экспедирование, монтаж и другие. MOVER - более тысячи профессиональных перевозчиков рядом с вами по лучшей цене в городе!'
    }
};

const mapState = state => ({
    lang: state.lang,
    userInfo: state.user,
    activeOrder: state.orders.activeOrder
});

const mapDispatch = ({ orders: { acceptedOrder, declinedOrder }, user: { getUserInfoFull }, calculator: { searchStop, searchStart, update }, ws: { connect }}) => ({
    getUserInfoFull     :    () => getUserInfoFull(),
    calculatorUpdate:   (data) => update(data),
    wsConnect:          () => { connect() },
    searchStop:         (data) => searchStop(data),
    searchStart:        (data) => searchStart(data),
    acceptedOrder:      (orderId) => acceptedOrder(orderId),
    declinedOrder:      (orderId) => declinedOrder(orderId),
});

export default withRematch(initStore, mapState, mapDispatch)(TariffPage);
